import { createTagApi } from 'api/tag';
import HashTag from 'models/hashtag';

export function createTag({ teamId, name, displayName, tagType, parentTagId }) {
  return createTagApi({ teamId, name, displayName, tagType, parentTagId }).then((res) => {
    if (!res.entity) throw Error('Tag creation successful but no data returned');
    const tag = new HashTag();
    tag.fromJSON(res.entity);
    return tag;
  });
}
